import priceTypeHtml from './priceType.html';

class PriceTypeController {
    constructor($scope, priceTypeService, translateService) {
        'ngInject';
        this.service = priceTypeService;
        this.translate = translateService;
    }

    $onInit() {
        this.service.setPriceType(this.type);
    }

    savePriceType(type) {
        if (!this.service.saving) {
            this.service.savePriceType(type);
        }
    }
}

let priceTypeComponent = {
    bindings: {
        type: '@',
        tooltip: '@'
    },
    template: priceTypeHtml,
    controller: PriceTypeController
};

export default priceTypeComponent;
